import React from "react";
import PayoutGrid from "../../PayoutTable/PayoutGrid";
import PayoutOptionsPanel from "./PayoutOptionsPanel";
import {
  columnMissesLastPlaceFloor,
  estimatedPrizeFund,
  isPayoutPlanningComplete,
  prizeFundForColumn,
} from "../../../utility/generateShapedPayoutTable";

const PayoutTableWorkspace = ({
  canEdit,
  showMore,
  onToggleMore,
  places,
  shape,
  ratioNumerator,
  ratioDenominator,
  payoutData,
  planning,
  onPlanningChange,
  isEditing,
  onChangeField,
  onResetRecommended,
  isRecommended,
  optionsLocked,
  onEditCells,
  onSave,
  onCancel,
  saving,
  canSave,
  calculateColumnTotal,
  isColumnValid,
  onPercentageChange,
  onKeyDown,
  onAddColumn,
  onDeleteColumn,
  previewQuantity,
  allowPersist = true,
  saveLabel,
  idPrefix,
  entries,
  onEntriesChange,
  entriesHint,
  onExport,
  exportColumnDisabled,
  exportingKey,
}) => {
  const getColumnPrizeFund = (quantity) => {
    if (!isPayoutPlanningComplete(planning)) return 0;
    const actual = estimatedPrizeFund(entries, planning.prizePerEntry);
    if (actual > 0 && Number(previewQuantity) > 0) {
      return Number(quantity) === Number(previewQuantity) ? actual : 0;
    }
    return prizeFundForColumn(
      quantity,
      planning,
      ratioNumerator,
      ratioDenominator
    );
  };
  const isColumnFloorMiss = (quantity) =>
    columnMissesLastPlaceFloor(
      payoutData,
      quantity,
      planning,
      ratioNumerator,
      ratioDenominator,
      getColumnPrizeFund(quantity)
    );

  return (
    <div className="flex flex-col gap-4 sm:gap-6 min-w-0">
      <PayoutOptionsPanel
        canEdit={canEdit}
        showMore={showMore}
        onToggleMore={onToggleMore}
        places={places}
        shape={shape}
        ratioNumerator={ratioNumerator}
        ratioDenominator={ratioDenominator}
        payoutData={payoutData}
        planning={planning}
        onPlanningChange={onPlanningChange}
        isEditing={isEditing}
        onChangeField={onChangeField}
        onResetRecommended={onResetRecommended}
        isRecommended={isRecommended}
        optionsLocked={optionsLocked}
        onEditCells={onEditCells}
        onSave={onSave}
        onCancel={onCancel}
        saving={saving}
        canSave={canSave}
        allowPersist={allowPersist}
        saveLabel={saveLabel}
        idPrefix={idPrefix}
        entries={entries}
        onEntriesChange={onEntriesChange}
        entriesHint={entriesHint}
        onExport={onExport}
        exportColumnDisabled={exportColumnDisabled}
        exportingKey={exportingKey}
      />

      <div className="min-w-0">
        <PayoutGrid
          payoutData={payoutData}
          isEditing={canEdit && isEditing}
          calculateColumnTotal={calculateColumnTotal}
          isColumnValid={isColumnValid}
          onPercentageChange={onPercentageChange}
          onKeyDown={onKeyDown}
          onAddColumn={onAddColumn}
          onDeleteColumn={onDeleteColumn}
          showColumnControls={canEdit && isEditing}
          previewQuantity={previewQuantity}
          getColumnPrizeFund={getColumnPrizeFund}
          lastPlaceFloor={planning?.lastPlaceDollars}
          isColumnFloorMiss={isColumnFloorMiss}
          ratioNumerator={ratioNumerator}
          ratioDenominator={ratioDenominator}
          roundToWholeDollars={planning?.roundToWholeDollars !== false}
          onSave={canEdit ? onSave : undefined}
          onCancel={canEdit ? onCancel : undefined}
          saving={saving}
          canSave={canSave}
          saveLabel={saveLabel}
        />
      </div>
    </div>
  );
};

export default PayoutTableWorkspace;
